/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 17 2023
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Column, Row } from "@/frameworks/designStuff/components";

export const fullWidthStyle = css`
	width: 100%;
	padding: 0 0 0 2px;
`;

export const infoAreaStyle = css`
	padding: 0 0 0 4px;
`;

export const MiniProfileWrapper = styled(Row.div)`
	padding: 12px 16px;
	width: 320px;
	background: ${({ theme }) => theme.colors.neutral_00_100};
	box-shadow:
		0px 0px 4px rgba(0, 0, 0, 0.04),
		0px 8px 12px rgba(0, 0, 0, 0.12);
	border-radius: 8px;
	position: relative;
	min-height: 100px;
`;

export const ProfileInfoWrapper = styled(Column)`
	width: 100%;
`;

export const ProfileButtonArea = styled(Row)`
	padding: 8px 0 0;
	width: 100%;
`;

export const iconLocation = css`
	margin-right: 4px;
`;

export const LongText = css`
	display: inline-block;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	max-width: 150px;
`;

export const AvatarColumn = styled(Column)`
	margin-right: 6px;
`;
export const Line = styled(Row)`
	background-color: ${({ theme }) => theme.colors.neutral_50_80};
	width: 100%;
	margin: 12px 0 0;
	height: 2px;
	opacity: 0.3;
`;

export const HeaderIcon = styled(Row)`
	position: absolute;
	top: 8px;
	right: 8px;
`;
